export default "__VITE_ASSET__DJJ8NJDC__"